<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-5">
<h1>Chapter 5</h1>
<p>Number Two still loved John Coltrane; all of it was still relevant to him. He sat in the dark in his study, listening to Coltrane’s classic, ‘A Love Supreme.’ He had a plethora of books, articles, research papers, and magazines along with albums and CDs in the study. His music was mostly jazz and classical, collected through the years. He took a long draw of marijuana, exhaled slowly, and drifted deeper in the music, smiling, thinking of his old friend.</p>
<p>“Hell, man, that’s not incongruent, jazz and classical music, only jazz is deeper, yeah.” He smiled, thinking of Charles. He always had the right timing with the appropriate phrase: In the pocket, nothing but net, or groove, referring to the old vinyl albums, later the cut. They all meant – perfect. Yeah, enjoy the ride; he closed his eyes, feeling a sense of absence. Charles died five years ago of leukemia complications.</p>
<p>He leaned back in the chair, listening to the legendary jazz saxophonist of the late ’60s, Coltrane. He sipped his brandy, took another long draw of marijuana, and slowly exhaled. He always loved a puff or two; it relaxed him, cleared his mind, as he lifted his glass to Charles.</p>
<p>He focused back on the issue. This could be it. Dr. David Burton must know something intriguing for Brizion to go after him, leaving his footprints, faded as they were. He chuckled as he exhaled again, feeling the high sensation begin to engulf him.</p>
<p>Number Two finally had a sense of excitement stirring in him. He had received information related to Brizion’s missteps. Awaiting a fuller report – and the first report on Dr. David Burton this evening.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?2b7ab336